import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  url: string;
  event_types: string[];
  enabled?: boolean;
  secret?: string;
};

type MutationResponse = {
  status: number;
  data: { forward_id: string };
};

export const useCreateWebhookForwardMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while creating the webhook forward',
    endpoint: '/api/admin/whatsapp/webhook-forwards',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
